module.exports = __webpack_public_path__ + "static/sopas-54390cbc287cbe22c02536195f7f6ab9.jpg";